<template>
<div :class="$style.nav">
    <router-link
        v-for="{ name, path, exact } in items"
        :key="name"
        :to="path"
        :exact="exact"
        @click.native="onClickNav($event, name)">
        {{ $t(`page.${name}`) }}
    </router-link>
    <a
        :href="whale_lab"
        target="_blank"
        @click="onClickNav($event, 'lab')">{{ $t("whale_lab.title") }}</a>
    <a
        :href="homepage_notices"
        target="_blank"
        @click="onClickNav($event, 'developers')">{{ $t("notices.title") }}</a>
</div>
</template>

<script>
import { GUIDE, DEVELOPER } from "@/router/path";
import { whale_lab, homepage_notices } from "@/data/links";
import { mapGetters } from "vuex";

export default {
    data: () => ({ whale_lab, homepage_notices }),
    computed: {
        ...mapGetters(["hasProject"]),
        items() {
            const { name } = this.$route;
            return [
                { name: "guide", path: GUIDE },
                ...this.hasProject
                    ? [
                        {
                            name: "project",
                            path: DEVELOPER,
                            exact: ["developerRegister", "welcome"].includes(
                                name
                            )
                        }
                    ]
                    : []
            ];
        }
    },
    methods: {
        onClickNav(e, name) {
            this.$nc(e, `gnb.${name}`);
        }
    }
};
</script>

<style lang="scss" module>
@use "@/assets/scss/mixins" as m;
@use "@material/typography/typography";

.nav {
    display: flex;
    gap: 50px;
    margin-left: 70px;
    padding: 0;
    font-size: typography.px-to-rem(16px);
    @include m.lg {
        display: none;
    }
    a {
        color: white;
        &:hover,
        &:global(.router-link-active) {
            color: #41a2fd;
        }
    }
}
</style>
